export const ANIMATION_TIMEOUT = 500;
export const NO_OVERFLOW_CLASS_NAME = 'no-overflow';
